import { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import {
  getReactSelectValue,
  ReactSelectInput,
} from '@hivebrite/design-system/Inputs';

import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';
import isInBO from 'hb-react/shared/utils/isInBO';

const defaultHeadings = [1, 2];

const normalOption = { value: '', label: s__('Article|Normal') };
const headingOptions = [
  { value: 1, label: s__('Article|Heading 1') },
  { value: 2, label: s__('Article|Heading 2') },
  { value: 3, label: s__('Article|Heading 3') },
  { value: 4, label: s__('Article|Heading 4') },
  { value: 5, label: s__('Article|Heading 5') },
];

const Headers = () => {
  const {
    id,
    quillRef,
    format,
    options: { toolbar: toolbarOptions },
  } = useQuillEditorContext();

  const availableOptions = useMemo(() => {
    const availableHeadings =
      (typeof toolbarOptions?.header === 'object' &&
        toolbarOptions?.header?.headings) ||
      defaultHeadings;

    return [
      normalOption,
      ...headingOptions.filter((headingOption) =>
        availableHeadings.includes(headingOption.value),
      ),
    ];
  }, [toolbarOptions?.header]);

  const inBO = isInBO();

  const [selectedValue, setSelectedValue] = useState(
    getReactSelectValue(availableOptions, ''),
  );

  useEffect(() => {
    setSelectedValue(
      format?.header
        ? getReactSelectValue(availableOptions, format.header)
        : getReactSelectValue(availableOptions, ''),
    );
  }, [availableOptions, format?.header]);

  const handleSelectChange = (option) => {
    quillRef?.current?.format('header', option.value, 'user');
  };

  return (
    <WrapperStyled>
      {!inBO && <TextStyled>{__('Style:')}</TextStyled>}
      <SelectWrapperStyled>
        <ReactSelectInput
          id={id ? `article-style-${id}` : 'article-style'}
          name={id ? `article-style-${id}` : 'article-style'}
          ariaLabel={__('Style')}
          options={availableOptions}
          onChange={handleSelectChange}
          isSearchable={false}
          value={selectedValue}
          menuPosition="fixed"
          variant="small"
        />
      </SelectWrapperStyled>
    </WrapperStyled>
  );
};

export default Headers;

const WrapperStyled = styled(Box).attrs({
  alignItems: 'center',
  mr: 2,
  my: 2,
})``;

const TextStyled = styled(Box).attrs({
  display: 'block',
  font: 'body-semibold-asphalt',
  mr: 2,
  flex: '0 0 auto',
})``;

const SelectWrapperStyled = styled(Box).attrs({
  display: 'block',
  minWidth: 160,
})``;
